import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dataset.instruction');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dataset-instruction',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dataset.instruction/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageDatasetInstructionComponent implements OnInit {
    public list: any[] = [];
    public loading: boolean = true;
    public search: string = '';
    public showCreateModal: boolean = false;
    public newDataset: any = { title: '', collection_id: '', prompt: '', tone: '', task_types: [], response_length: '' };
    public collections: any[] = [];
    public showDeleteModal: boolean = false;
    public deleteTarget: any = null;
    public expandedItems: any = {};

    public toneOptions = [
        { value: 'friendly', label: '친근한 상담형' },
        { value: 'professional', label: '전문적 학술형' },
        { value: 'educational', label: '교육적 설명형' },
    ];

    public taskTypeOptions = [
        { value: 'consultation', label: '진료 상담' },
        { value: 'prescription', label: '처방 설명' },
        { value: 'symptom', label: '증상 분석' },
        { value: 'concept', label: '개념 설명' },
        { value: 'comparison', label: '비교 분석' },
    ];

    public responseLengthOptions = [
        { value: 'short', label: '간결' },
        { value: 'medium', label: '보통' },
        { value: 'detailed', label: '상세' },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call('list', { text: this.search });
        if (code === 200) {
            this.list = data.list || [];
            this.collections = data.collections || [];
        }
        this.loading = false;
        await this.service.render();
    }

    public async create() {
        if (!this.newDataset.title.trim()) return;
        const { code } = await wiz.call('create', {
            title: this.newDataset.title,
            collection_id: this.newDataset.collection_id,
            prompt: this.newDataset.prompt,
            tone: this.newDataset.tone,
            task_types: JSON.stringify(this.newDataset.task_types),
            response_length: this.newDataset.response_length,
        });
        if (code === 200) {
            this.showCreateModal = false;
            this.newDataset = { title: '', collection_id: '', prompt: '', tone: '', task_types: [], response_length: '' };
            await this.load();
        }
        await this.service.render();
    }

    public toggleTaskType(value: string) {
        const idx = this.newDataset.task_types.indexOf(value);
        if (idx >= 0) {
            this.newDataset.task_types.splice(idx, 1);
        } else {
            this.newDataset.task_types.push(value);
        }
    }

    public async confirmDelete() {
        if (!this.deleteTarget) return;
        const { code } = await wiz.call('delete', { id: this.deleteTarget.id });
        if (code === 200) {
            this.showDeleteModal = false;
            this.deleteTarget = null;
            await this.load();
        }
        await this.service.render();
    }

    public async openDelete(item: any) {
        this.deleteTarget = item;
        this.showDeleteModal = true;
        await this.service.render();
    }

    public statusLabel(status: string): string {
        const map: any = { draft: '초안', generating: '생성 중', review: '검수 중', completed: '완료' };
        return map[status] || status;
    }

    public statusColor(status: string): string {
        const map: any = {
            draft: 'bg-zinc-100 text-zinc-600',
            generating: 'bg-amber-50 text-amber-600',
            review: 'bg-violet-50 text-violet-600',
            completed: 'bg-emerald-50 text-emerald-600'
        };
        return map[status] || 'bg-zinc-100 text-zinc-600';
    }

    public toneLabel(tone: string): string {
        const found = this.toneOptions.find(t => t.value === tone);
        return found ? found.label : tone || '-';
    }

    public taskTypeLabel(value: string): string {
        const found = this.taskTypeOptions.find(t => t.value === value);
        return found ? found.label : value;
    }

    public reviewPercent(item: any): number {
        const total = item.total_count || 0;
        if (total === 0) return 0;
        const reviewed = (item.approved_count || 0) + (item.rejected_count || 0) + (item.skipped_count || 0);
        return Math.round((reviewed / total) * 100);
    }

    public pendingCount(item: any): number {
        const total = item.total_count || 0;
        const reviewed = (item.approved_count || 0) + (item.rejected_count || 0) + (item.skipped_count || 0);
        return Math.max(0, total - reviewed);
    }

    public async toggleDetails(item: any) {
        this.expandedItems[item.id] = !this.expandedItems[item.id];
        await this.service.render();
    }

    public isExpanded(item: any): boolean {
        return !!this.expandedItems[item.id];
    }

    public navigateTo(path: string) {
        this.service.href(path);
    }
}

export default PageDatasetInstructionComponent;